import { onMounted } from "vue";
import { availableRoutes, refreshRoutes, addDynamicRoutes, addDynamicRoute, removeDynamicRoute } from "./routeManager";

export function useDynamicRoutes() {
  onMounted(() => {
    if (availableRoutes.value.length === 0) {
      refreshRoutes();
    }
  });

  return {
    availableRoutes,
    addDynamicRoute,
    addDynamicRoutes,
    removeDynamicRoute,
    refreshRoutes,
  };
}
